import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromLinksStore from './links-store.reducer';

export const selectLinksStoreState =
    createFeatureSelector<fromLinksStore.State>(
        fromLinksStore.linksStoreFeatureKey
    );

export const selectLinksLoaded = createSelector(
    selectLinksStoreState,
    (state) => state.linksLoaded
);

export const selectLinksVM = createSelector(selectLinksStoreState, (state) => ({
    links: state.links,
}));
